export default class PartnerDetailsResponse {
    constructor(supportedLocales) {
        this.id = null;
        this.startAt = undefined;
        this.endAt = undefined;
        this.name = undefined;
        this.longitude = undefined;
        this.latitude = undefined;
        this.email = undefined;
        this.phoneNumber = undefined;
        this.link = undefined;
        this.status = undefined;
        this.city = undefined;
        this.hoursAvailabilities = [];
        this.streetName = undefined;
        this.streetNumber = undefined;
        this.houseNumber = undefined;
        this.postalCode = undefined;
        this.logo = undefined;
        this.translations = [];

        supportedLocales?.forEach((element) => {
            this.translations[element] = {
                description: '',
            };
        });
        this.supportedLocales = supportedLocales;
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;
            to.locale = from.locale;
            to.startAt = from.startAt;
            to.endAt = from.endAt;
            to.name = from.name;
            to.longitude = from.longitude;
            to.latitude = from.latitude;
            to.contact = from.contact;
            to.email = from.email;
            to.phoneNumber = from.phoneNumber;
            to.link = from.link;
            to.status = from.status;
            to.city = from.city;
            to.streetName = from.streetName;
            to.postalCode = from.postalCode;
            to.streetNumber = from.streetNumber;
            to.houseNumber = from.houseNumber;
            to.hoursAvailabilities = from.hoursAvailabilities;
            to.logo = from.logo;
            to.supportedLocales?.forEach((element) => {
                to.translations[element] = {
                    description: from.translations[element]?.description,
                };
            });
        } else {
            to = new PartnerDetailsResponse();
        }
    }

    static copy(from, to) {
        // const to = new PartnerDetailsResponse();
        PartnerDetailsResponse.assign(from, to);
        return to;
    }
}
